import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {GlobalLoaderService} from '../../services/global-loader.service';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';

declare var $: any;
declare var Snackbar: any;
declare var navigator: any;

@Component({
  selector: 'app-share-panel',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, RouterModule],
  templateUrl: './share-panel.component.html',
  styleUrls: ['./share-panel.component.scss']
})
export class SharePanelComponent implements OnInit {

  @Input('modalId') modalId: string;
  @Input('link') link: string;
  @ViewChild('copyLinkEl', {static: true}) copyLinkEl: ElementRef;
  @Input('closeModalFn') closeModalFn: any;

  constructor(private loader: GlobalLoaderService,
              private translate: TranslateService) {
  }

  async ngOnInit() {
    await this.loader.loadExternalStyles('/plugins/notification/snackbar/snackbar.min.css');
    await this.loader.loadExternalScript('/plugins/notification/snackbar/snackbar.min.js');
    await this.loader.loadExternalScript('https://kit.fontawesome.com/7cc96e74fa.js');
  }

  async copyLink() {
    this.copyLinkEl.nativeElement.select();
    document.execCommand('copy');
    navigator.clipboard.writeText(this.link);
    this.showToast(await this.translate.get('Link has been copied').toPromise());
  }

  closeModal() {
    if (this.closeModalFn) {
      this.closeModalFn();
    }
  }

  showToast(msg) {
    Snackbar.show({
      text: msg,
      pos: 'bottom-center'
    });
  }
}
